<div class="overview-card">
  <div class="header-container">
    <div class="title-container tw-items-center">
      <div class="tw-font-bold section-title">{{ title }}</div>
      <div class="edit" mat-raised-button color="primary">
        <div class="edit-text-container" data-cy="edit-data-list" (click)="handleEdit()">
          <span>Edit</span>
        </div>
      </div>
    </div>
  </div>
  <div class="content-container" *ngIf="!loading">
    <div *ngFor="let data of dataListHead; last as last; first as first">
      <div *ngIf="data.sectionType === 'owners'" class="content-item-container" attr.data-cy="{{getAttributeName(data.label)}}">
          <span class="tw-py-2 tw-leading-none">{{ data.label }}</span>
          <p [className]="data.cssClass + ' mb-0 tw-leading-none'">
            <span *ngIf="!!data.metadata?.extraLabel" [className]="data.metadata?.cssClass">{{ data.metadata?.extraLabel }}</span>
              <span>{{ data.value | percentage }}</span>
          </p>
      </div>
      <div *ngIf="data.sectionType === 'relationships' && first">
        <div class="content-item-container">
          <div class="content-item">
            <p *ngIf="data.value.employee">Employee</p>
            <p *ngIf="data.value.owner">Owner</p>
          </div>
          <div class="content-item">
            <p>Relationship</p>
          </div>
          <div class="content-item">
            <p>Owner</p>
          </div>
        </div>
        <hr>
      </div>
      <div *ngIf="data.sectionType === 'relationships'" class="content-item-container" attr.data-cy="{{getAttributeName(data.label)}}">
        <div class="content-item">
          <p>{{data.value.employee || data.value.ownerLabel}}</p>
        </div>
        <div class="content-item">
          <p>{{data.value.relationshipLabel}}</p>
        </div>
        <div class="content-item">
          <p>{{data.value.contactLabel}}</p>
        </div>
      </div>
      <hr *ngIf="!last">
    </div>
    <div *ngIf="dataListHead.length === 0">
      <p class="tw-text-center m-0 tw-py-3">No {{title}}</p>
    </div>
  </div>
  <div *ngIf="loading" style="display: flex; justify-content: center; padding: 20px;">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</div>
